import * as chrono from 'chrono-node'
import { PERIOD_KEYWORDS } from '../../date/periodKeywords'
import type { LanguagePack } from './types'

export const en: LanguagePack = {
  chrono: chrono.en.casual.clone(),
  deadlineWords: ['by'],
  durationLeads: ['for'],
  durationUnits: {
    m: 1, min: 1, mins: 1, minute: 1, minutes: 1,
    h: 60, hr: 60, hrs: 60, hour: 60, hours: 60,
    d: 'day', day: 'day', days: 'day',
  },
  recurrenceLeads: ['every', 'daily', 'weekly', 'monthly', 'yearly', 'annually'],
  weekdayShort: ['mon', 'tue', 'tues', 'wed', 'thu', 'thur', 'thurs', 'fri', 'sat', 'sun'],
  prepositions: ['on'],
  periodNouns: ['morning', 'noon', 'afternoon', 'evening', 'night'],
  periodWords: { ...PERIOD_KEYWORDS, tonight: 'evening' },
  periodAdverbs: {},
}
